module.exports = __webpack_public_path__ + "media/images/font/flaticon-164f0c31f99d7cd58f854f17952693d2.woff";